import React from 'react';
import Header from '../Header/Header';

const Home = () => {
    return (
        <div id="home">
            <Header />
        </div>
    );
};

export default Home;